import React, { useState, useEffect } from 'react';

export default function Landing({ onLogin }) {
  const [scrolled, setScrolled] = useState(false);
  const [formData, setFormData] = useState({ nombre: '', empresa: '', email: '', telefono: '', mensaje: '' });
  const [enviado, setEnviado] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Aquí se conectará con el backend de contacto
    setEnviado(true);
    setTimeout(() => setEnviado(false), 4000);
    setFormData({ nombre: '', empresa: '', email: '', telefono: '', mensaje: '' });
  };

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  const planes = [
 {
  nombre: 'Starter',
  precio: '$9,999',
  periodo: '/mes',
  setup: '$8,000 setup único',
  descripcion: 'Hasta 3 usuarios. Ideal para empresas logísticas que inician su transformación digital.',
  color: '#00e5a0',
  features: [
    'Bitácora de viajes',
    'Directorio de carriers, clientes y rutas',
    'Creación de cartas de instrucciones',
    'Reportes con KPIs de alto impacto',
    'CRM y dashboard de tareas integrados',
  ],
  cta: 'Comenzar',
  destacado: false,
},
{
  nombre: 'Business',
  precio: '$14,999',
  periodo: '/mes',
  setup: '$11,000 setup único',
  descripcion: 'Para operaciones logísticas en crecimiento.',
  color: '#00e5a0',
  features: [
    'Hasta 10 usuarios',
    'Todo lo del plan Starter',
    'Soporte prioritario',
    'Onboarding guiado',
    'Landing page',
  ],
  cta: 'Comenzar',
  destacado: true,
},
  {
    nombre: 'A Medida',
    precio: 'Desde $25,000',
    periodo: '/mes',
    setup: 'Setup personalizado',
    descripcion: 'Para operaciones con requerimientos específicos y flujos de automatización avanzados.',
    color: '#8b5cf6',
    features: [
      'Usuarios ilimitados',
      'Todo lo del plan Business',
      'Integraciones a la medida',
      'Desarrollo de módulos custom',
      'SLA garantizado',
    ],
    cta: 'Agendar llamada',
    destacado: false,
  },
];

  const beneficios = [
    { titulo: 'Visibilidad total', desc: 'Monitorea cada viaje en tiempo real. Eventos, gastos y alertas en un solo lugar.' },
    { titulo: 'Comunicación automática', desc: 'Notifica a tus clientes automáticamente con cada actualización de su carga.' },
    { titulo: 'Métricas que importan', desc: 'Reportes por carrier, cliente, ruta y ejecutivo. Toma decisiones con datos reales.' },
    { titulo: 'Implementación rápida', desc: 'Tu operación digitalizada en días, no meses. Sin infraestructura compleja.' },
    { titulo: 'Digitalización como ventaja competitiva', desc: 'Mejora el flujo de tus operaciones. Aumenta tu productividad.' },
    { titulo: 'Soporte cercano', desc: 'Acompañamiento real por WhatsApp. No tickets, no chatbots. Personas reales.' },
  ];

  const addons = [
    {
    nombre: 'WhatsApp Business API',
    precio: '$1,999',
    periodo: '/mes',
    setup: '$2,000 setup único',
    desc: 'Notificaciones automáticas a tus clientes en cada hito del viaje. Mensajes personalizados con plantillas configurables.',
    color: '#25d366',
    },
    {
    nombre: 'Facturación CFDI',
    precio: '$600',
    periodo: '/mes',
    setup: '$2,000 setup único',
    desc: 'Genera y timbra facturas electrónicas directamente desde la plataforma. Integración con el SAT.',
    color: '#25d366',
    },
    {
    nombre: 'Integración GPS',
    precio: '$800',
    periodo: '/mes',
    setup: '$2,000 setup único',
    desc: 'Conecta tu proveedor GPS (A disponibilidad) directamente a LogiConnect. Visibilidad real de tu flota.',
    color: '#25d366',
    },
  ];

  const s = {
    nav: {
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
      background: scrolled ? 'rgba(10,12,16,0.95)' : 'transparent',
      backdropFilter: scrolled ? 'blur(12px)' : 'none',
      borderBottom: scrolled ? '1px solid #222730' : '1px solid transparent',
      transition: 'all 0.3s ease',
      padding: '0 40px', height: '64px',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    },
    logo: { fontSize: '22px', fontWeight: '800', letterSpacing: '-0.5px', cursor: 'pointer' },
    navLink: { fontSize: '14px', color: '#9ca3af', cursor: 'pointer', fontWeight: '500', transition: 'color 0.2s' },
    btnPrimary: { background: '#00e5a0', color: '#000', border: 'none', borderRadius: '8px', padding: '10px 20px', fontSize: '14px', fontWeight: '700', cursor: 'pointer' },
    btnOutline: { background: 'transparent', border: '1px solid #222730', color: '#e8eaf0', borderRadius: '8px', padding: '10px 20px', fontSize: '14px', fontWeight: '500', cursor: 'pointer' },
    section: { padding: '100px 40px', maxWidth: '1200px', margin: '0 auto' },
    tag: { display: 'inline-block', background: 'rgba(0,229,160,0.1)', border: '1px solid rgba(0,229,160,0.2)', color: '#00e5a0', borderRadius: '20px', padding: '4px 14px', fontSize: '12px', fontWeight: '600', letterSpacing: '1px', textTransform: 'uppercase', marginBottom: '20px' },
    input: { width: '100%', background: '#111318', border: '1px solid #222730', borderRadius: '8px', padding: '12px 16px', color: '#e8eaf0', fontSize: '14px', outline: 'none', boxSizing: 'border-box' },
  };

  return (
    <div style={{ background: '#0a0c10', minHeight: '100vh', color: '#e8eaf0', fontFamily: "'DM Sans', 'Helvetica Neue', sans-serif" }}>

      {/* NAV */}
      <nav style={s.nav}>
        <div style={s.logo} onClick={() => scrollTo('hero')}>
          <img src="/logo-dark.svg" alt="LogiConnect" style={{ height: '32px', marginTop: '4px' }} />
        </div>
        <div style={{ display: 'flex', gap: '32px', alignItems: 'center' }}>
          {[['Beneficios', 'beneficios'], ['Planes', 'planes'], ['Contacto', 'contacto']].map(([label, id]) => (
            <span key={id} onClick={() => scrollTo(id)}
              style={s.navLink}
              onMouseEnter={e => e.target.style.color = '#ffffff'}
              onMouseLeave={e => e.target.style.color = '#9ca3af'}>
              {label}
            </span>
          ))}
          <button onClick={onLogin} style={s.btnPrimary}>Iniciar sesión</button>
        </div>
      </nav>

      {/* HERO */}
      <section id="hero" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '80px 40px 60px', position: 'relative', overflow: 'hidden' }}>
        {/* Background grid */}
        <div style={{ position: 'absolute', inset: 0, backgroundImage: 'linear-gradient(rgba(0,229,160,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(0,229,160,0.03) 1px, transparent 1px)', backgroundSize: '60px 60px', pointerEvents: 'none' }}></div>
        {/* Glow */}
        <div style={{ position: 'absolute', top: '30%', left: '50%', transform: 'translate(-50%, -50%)', width: '600px', height: '600px', background: 'radial-gradient(circle, rgba(0,229,160,0.06) 0%, transparent 70%)', pointerEvents: 'none' }}></div>

        <div style={{ position: 'relative', maxWidth: '800px' }}>
          <div style={s.tag}>Plataforma Logística SaaS</div>
          <h1 style={{ fontSize: '64px', fontWeight: '800', lineHeight: 1.1, letterSpacing: '-2px', marginBottom: '24px', color: '#ffffff' }}>
            Controla tu operación logística{' '}
            <span style={{ color: '#00e5a0' }}>en tiempo real</span>
          </h1>
          <p style={{ fontSize: '20px', color: '#9ca3af', lineHeight: 1.6, marginBottom: '40px', maxWidth: '600px', margin: '0 auto 40px' }}>
            Bitácora de viajes, alertas, reportes y comunicación con clientes.  Todo en una plataforma diseñada para empresas logísticas mexicanas.
          </p>
          <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button onClick={() => scrollTo('planes')} style={{ ...s.btnPrimary, padding: '14px 32px', fontSize: '16px' }}>
              Ver planes →
            </button>
            <button onClick={() => scrollTo('contacto')} style={{ ...s.btnOutline, padding: '14px 32px', fontSize: '16px' }}>
              Agendar demo
            </button>
          </div>
          <div style={{ display: 'flex', gap: '40px', justifyContent: 'center', marginTop: '60px', flexWrap: 'wrap' }}>
            {[['100%', 'Digital'], ['Tiempo real', 'Monitoreo'], ['Automático', 'Reportes']].map(([val, label]) => (
              <div key={label} style={{ textAlign: 'center' }}>
                <div style={{ fontSize: '28px', fontWeight: '800', color: '#00e5a0' }}>{val}</div>
                <div style={{ fontSize: '13px', color: '#6b7280', marginTop: '4px' }}>{label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* BENEFICIOS */}
      <section id="beneficios" style={{ padding: '100px 40px', background: '#0d1117' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '64px' }}>
            <div style={s.tag}>Por qué LogiConnect</div>
            <h2 style={{ fontSize: '42px', fontWeight: '800', letterSpacing: '-1px', color: '#ffffff', marginBottom: '16px' }}>
              Mejora la productividad de tu equipo
            </h2>
            <p style={{ fontSize: '18px', color: '#6b7280', maxWidth: '500px', margin: '0 auto' }}>
              Diseñado con y para operadores logísticos en México.
            </p>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '24px' }}>
            {beneficios.map((b, i) => (
              <div key={i} style={{ background: '#111318', border: '1px solid #222730', borderRadius: '12px', padding: '28px', transition: 'border-color 0.2s' }}
                onMouseEnter={e => e.currentTarget.style.borderColor = 'rgba(0,229,160,0.3)'}
                onMouseLeave={e => e.currentTarget.style.borderColor = '#222730'}>
                <div style={{ fontSize: '16px', fontWeight: '700', color: '#ffffff', marginBottom: '8px' }}>{b.titulo}</div>
                <div style={{ fontSize: '14px', color: '#6b7280', lineHeight: 1.6 }}>{b.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PLANES */}
      <section id="planes" style={{ padding: '100px 40px' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '64px' }}>
            <div style={s.tag}>Precios</div>
            <h2 style={{ fontSize: '42px', fontWeight: '800', letterSpacing: '-1px', color: '#ffffff', marginBottom: '16px' }}>
              Planes sin sorpresas
            </h2>
            <p style={{ fontSize: '18px', color: '#6b7280' }}>
              Setup único, incluye onboarding guiado y manual de usuario + suscripción mensual.
            </p>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '24px', alignItems: 'start' }}>
            {planes.map((plan, i) => (
              <div key={i} style={{
                background: plan.destacado ? 'linear-gradient(135deg, #111318 0%, #0d1a13 100%)' : '#111318',
                border: `1px solid ${plan.destacado ? 'rgba(0,229,160,0.4)' : '#222730'}`,
                borderRadius: '16px', padding: '32px', position: 'relative',
                transform: plan.destacado ? 'scale(1.03)' : 'scale(1)',
                boxShadow: plan.destacado ? '0 0 40px rgba(0,229,160,0.08)' : 'none',
              }}>
                {plan.destacado && (
                  <div style={{ position: 'absolute', top: '-14px', left: '50%', transform: 'translateX(-50%)', background: '#00e5a0', color: '#000', fontSize: '11px', fontWeight: '800', padding: '4px 16px', borderRadius: '20px', letterSpacing: '1px', textTransform: 'uppercase' }}>
                    Más popular
                  </div>
                )}
                <div style={{ fontSize: '13px', fontWeight: '700', color: plan.color, textTransform: 'uppercase', letterSpacing: '2px', marginBottom: '12px' }}>{plan.nombre}</div>
                <div style={{ display: 'flex', alignItems: 'baseline', gap: '4px', marginBottom: '4px' }}>
                  <span style={{ fontSize: '38px', fontWeight: '800', color: '#ffffff', letterSpacing: '-1px' }}>{plan.precio}</span>
                  <span style={{ fontSize: '16px', color: '#6b7280' }}>{plan.periodo}</span>
                </div>
                <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '16px' }}>{plan.setup}</div>
                <p style={{ fontSize: '14px', color: '#9ca3af', lineHeight: 1.6, marginBottom: '24px', minHeight: '60px' }}>{plan.descripcion}</p>
<div style={{ borderTop: '1px solid #222730', paddingTop: '24px', marginBottom: '16px' }}>
  {plan.features.map((f, j) => (
    <div key={j} style={{ display: 'flex', gap: '10px', alignItems: 'flex-start', marginBottom: '12px' }}>
      <span style={{ color: plan.color, fontSize: '14px', flexShrink: 0, marginTop: '1px' }}>✓</span>
      <span style={{ fontSize: '14px', color: '#9ca3af' }}>{f}</span>
    </div>
  ))}
</div>
{plan.setupIncludes && (
  <div style={{ background: 'rgba(0,229,160,0.04)', border: '1px solid rgba(0,229,160,0.12)', borderRadius: '8px', padding: '14px', marginBottom: '28px' }}>
    <div style={{ fontSize: '11px', color: '#00e5a0', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '10px' }}>El setup incluye</div>
    {plan.setupIncludes.map((s, j) => (
      <div key={j} style={{ display: 'flex', gap: '8px', alignItems: 'flex-start', marginBottom: '6px' }}>
        <span style={{ color: '#00e5a0', fontSize: '12px', flexShrink: 0 }}>→</span>
        <span style={{ fontSize: '12px', color: '#6b7280' }}>{s}</span>
      </div>
    ))}
  </div>
)}
                <button onClick={() => scrollTo('contacto')}
                  style={{ width: '100%', padding: '12px', borderRadius: '8px', fontSize: '14px', fontWeight: '700', cursor: 'pointer', border: 'none', background: plan.destacado ? '#00e5a0' : plan.color === '#8b5cf6' ? 'rgba(139,92,246,0.15)' : 'rgba(0,229,160,0.1)', color: plan.destacado ? '#000' : plan.color }}>
                  {plan.cta} →
                </button>
              </div>
            ))}
          </div>
          <div style={{ textAlign: 'center', marginTop: '40px', fontSize: '14px', color: '#6b7280' }}>
            ¿Más de 10 usuarios o necesidades específicas?{' '}
            <span onClick={() => scrollTo('contacto')} style={{ color: '#00e5a0', cursor: 'pointer', fontWeight: '600' }}>Contáctanos para un plan personalizado</span>
          </div>
        </div>
      </section>

    {/* ADDONS */}
    <section style={{ padding: '0 40px 100px' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '48px' }}>
          <div style={s.tag}>Add-ons</div>
          <h2 style={{ fontSize: '36px', fontWeight: '800', letterSpacing: '-1px', color: '#ffffff', marginBottom: '12px' }}>
            Potencia tu plan
          </h2>
          <p style={{ fontSize: '16px', color: '#6b7280' }}>
            Activa solo lo que necesitas. Sin compromisos adicionales.
          </p>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '24px' }}>
          {addons.map((addon, i) => (
            <div key={i} style={{ background: '#111318', border: '1px solid #222730', borderRadius: '12px', padding: '28px', transition: 'border-color 0.2s' }}
              onMouseEnter={e => e.currentTarget.style.borderColor = addon.color + '50'}
              onMouseLeave={e => e.currentTarget.style.borderColor = '#222730'}>
              <div style={{ fontSize: '28px', marginBottom: '12px' }}>{addon.icon}</div>
              <div style={{ fontSize: '13px', fontWeight: '700', color: addon.color, textTransform: 'uppercase', letterSpacing: '2px', marginBottom: '8px' }}>{addon.nombre}</div>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: '4px', marginBottom: '4px' }}>
                <span style={{ fontSize: '28px', fontWeight: '800', color: '#ffffff' }}>{addon.precio}</span>
                <span style={{ fontSize: '14px', color: '#6b7280' }}>{addon.periodo}</span>
              </div>
              {addon.setup && <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '12px' }}>{addon.setup}</div>}
              <p style={{ fontSize: '13px', color: '#9ca3af', lineHeight: 1.6, marginTop: '12px' }}>{addon.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

      {/* CTA INTERMEDIO */}
      <section style={{ padding: '80px 40px', background: '#0d1117' }}>
        <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center', background: 'linear-gradient(135deg, rgba(0,229,160,0.05) 0%, rgba(0,229,160,0.02) 100%)', border: '1px solid rgba(0,229,160,0.15)', borderRadius: '20px', padding: '60px 40px' }}>
          <h2 style={{ fontSize: '36px', fontWeight: '800', letterSpacing: '-1px', color: '#ffffff', marginBottom: '16px' }}>
            ¿Listo para digitalizar tu operación?
          </h2>
          <p style={{ fontSize: '16px', color: '#9ca3af', marginBottom: '32px', lineHeight: 1.6 }}>
            Agenda una demo de 30 minutos. Te mostramos cómo funciona con datos de tu propia empresa.
          </p>
          <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button onClick={() => scrollTo('contacto')} style={{ ...s.btnPrimary, padding: '14px 32px', fontSize: '15px' }}>
              Agendar demo gratuita
            </button>
            <a href="https://wa.me/5218112345678?text=Hola,%20me%20interesa%20LogiConnect" target="_blank" rel="noreferrer"
              style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', background: 'rgba(37,211,102,0.1)', border: '1px solid rgba(37,211,102,0.3)', color: '#25d366', borderRadius: '8px', padding: '14px 32px', fontSize: '15px', fontWeight: '600', textDecoration: 'none' }}>
              WhatsApp
            </a>
          </div>
        </div>
      </section>

      {/* CONTACTO */}
      <section id="contacto" style={{ padding: '100px 40px' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '80px', alignItems: 'start' }}>
            <div>
              <div style={s.tag}>Contacto</div>
              <h2 style={{ fontSize: '42px', fontWeight: '800', letterSpacing: '-1px', color: '#ffffff', marginBottom: '20px', lineHeight: 1.1 }}>
                Hablemos de tu operación
              </h2>
              <p style={{ fontSize: '16px', color: '#9ca3af', lineHeight: 1.7, marginBottom: '40px' }}>
                Cuéntanos cómo funciona tu empresa y en menos de 24 horas te contactamos con una propuesta personalizada.
              </p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                  <div style={{ width: '44px', height: '44px', borderRadius: '10px', background: 'rgba(0,229,160,0.1)', border: '1px solid rgba(0,229,160,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', flexShrink: 0 }}>💬</div>
                  <div>
                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#ffffff', marginBottom: '2px' }}>WhatsApp directo</div>
                    <a href="https://wa.me/5218112345678" target="_blank" rel="noreferrer" style={{ fontSize: '14px', color: '#25d366', textDecoration: 'none' }}>+52 81 1234 5678</a>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                  <div style={{ width: '44px', height: '44px', borderRadius: '10px', background: 'rgba(0,229,160,0.1)', border: '1px solid rgba(0,229,160,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', flexShrink: 0 }}>📧</div>
                  <div>
                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#ffffff', marginBottom: '2px' }}>Email</div>
                    <a href="mailto:hola@logiconnect.mx" style={{ fontSize: '14px', color: '#00e5a0', textDecoration: 'none' }}>hola@logiconnect.mx</a>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                  <div style={{ width: '44px', height: '44px', borderRadius: '10px', background: 'rgba(0,229,160,0.1)', border: '1px solid rgba(0,229,160,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', flexShrink: 0 }}>⏱️</div>
                  <div>
                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#ffffff', marginBottom: '2px' }}>Tiempo de respuesta</div>
                    <div style={{ fontSize: '14px', color: '#6b7280' }}>Menos de 24 horas hábiles</div>
                  </div>
                </div>
              </div>
            </div>

            <div style={{ background: '#111318', border: '1px solid #222730', borderRadius: '16px', padding: '40px' }}>
              {enviado ? (
                <div style={{ textAlign: 'center', padding: '40px 0' }}>
                  <div style={{ fontSize: '48px', marginBottom: '16px' }}>✅</div>
                  <div style={{ fontSize: '18px', fontWeight: '700', color: '#00e5a0', marginBottom: '8px' }}>¡Mensaje enviado!</div>
                  <div style={{ fontSize: '14px', color: '#6b7280' }}>Te contactamos en menos de 24 horas.</div>
                </div>
              ) : (
                <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                    <div>
                      <label style={{ fontSize: '12px', color: '#9ca3af', display: 'block', marginBottom: '6px' }}>Nombre *</label>
                      <input required value={formData.nombre} onChange={e => setFormData({...formData, nombre: e.target.value})}
                        placeholder="Tu nombre" style={s.input} />
                    </div>
                    <div>
                      <label style={{ fontSize: '12px', color: '#9ca3af', display: 'block', marginBottom: '6px' }}>Empresa *</label>
                      <input required value={formData.empresa} onChange={e => setFormData({...formData, empresa: e.target.value})}
                        placeholder="Nombre de tu empresa" style={s.input} />
                    </div>
                  </div>
                  <div>
                    <label style={{ fontSize: '12px', color: '#9ca3af', display: 'block', marginBottom: '6px' }}>Email *</label>
                    <input required type="email" value={formData.email} onChange={e => setFormData({...formData, email: e.target.value})}
                      placeholder="correo@empresa.com" style={s.input} />
                  </div>
                  <div>
                    <label style={{ fontSize: '12px', color: '#9ca3af', display: 'block', marginBottom: '6px' }}>Teléfono / WhatsApp</label>
                    <input value={formData.telefono} onChange={e => setFormData({...formData, telefono: e.target.value})}
                      placeholder="+52 81 0000 0000" style={s.input} />
                  </div>
                  <div>
                    <label style={{ fontSize: '12px', color: '#9ca3af', display: 'block', marginBottom: '6px' }}>¿Cómo podemos ayudarte?</label>
                    <textarea value={formData.mensaje} onChange={e => setFormData({...formData, mensaje: e.target.value})}
                      placeholder="Cuéntanos sobre tu operación logística: número de viajes mensuales, usuarios, necesidades específicas..."
                      rows={4}
                      style={{ ...s.input, resize: 'vertical', fontFamily: 'inherit' }} />
                  </div>
                  <button type="submit" style={{ ...s.btnPrimary, padding: '14px', fontSize: '15px', marginTop: '8px' }}>
                    Enviar mensaje →
                  </button>
                  <div style={{ fontSize: '12px', color: '#6b7280', textAlign: 'center' }}>
                    También puedes escribirnos directo por{' '}
                    <a href="https://wa.me/5218112345678" target="_blank" rel="noreferrer" style={{ color: '#25d366', textDecoration: 'none', fontWeight: '600' }}>WhatsApp</a>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer style={{ borderTop: '1px solid #222730', padding: '40px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px' }}>
        <div>
          <img src="/logo-dark.svg" alt="LogiConnect" style={{ height: '20px' }} />
        </div>
        <div style={{ fontSize: '13px', color: '#6b7280' }}>
          © 2026 LogiConnect · Plataforma logística para México
        </div>
        <button onClick={onLogin} style={{ ...s.btnPrimary, padding: '8px 20px', fontSize: '13px' }}>
          Iniciar sesión
        </button>
      </footer>
    </div>
  );
}